export default function removeAllSlides() {
  var swiper = this;
  var slidesIndexes = [];

  for (var i = 0; i < swiper.slides.length; i += 1) {
    slidesIndexes.push(i);
  }

  swiper.removeSlide(slidesIndexes);
}


//////////////////
// WEBPACK FOOTER
// ./~/swiper/esm/components/core/manipulation/removeAllSlides.js
// module id = 1174
// module chunks = 168